const themeLightBackgroundShading = 'rgba(1, 2, 5, 0.67)';

export { themeLightBackgroundShading };
